export default __webpack_public_path__ + "static/media/calendar.6efbc90f.svg";